export default "__VITE_ASSET__f554f401__"